import { BETA_FEATURE_LLM_EVAL } from '@/lib/betaFeatures';
import { ORGANIZATION_USER_ROLES } from '@shared/constants';
import useBetaFeatureEnabled from '../useBetaFeatureEnabled';
import useCurrentOrganizationUserRole from './useCurrentOrganizationUserRole';

const useIsLLMOnlyUser = (): boolean => {
  const role = useCurrentOrganizationUserRole();
  const isLLMEvalEnabled = useBetaFeatureEnabled(BETA_FEATURE_LLM_EVAL);

  return isLLMEvalEnabled && role === ORGANIZATION_USER_ROLES.LLM_ONLY;
};

export default useIsLLMOnlyUser;
